var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 40,
    viewBox: "0 0 60 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4687 14L6 26.1021H12.5468L13.3584 24.1725H15.2136L16.0252 26.1021H23.2314V24.6294L23.8735 26.1021H27.6011L28.2432 24.5982V26.1021H43.2302L45.0525 24.2226L46.7589 26.1021L54.4565 26.1176L48.9705 20.0848L54.4565 14H46.8782L45.1043 15.8447L43.4517 14H27.1479L25.7478 17.1236L24.315 14H17.7819V15.4226L17.0551 14H11.4687ZM33.8486 15.7185H42.4548L45.0871 18.5618L47.8041 15.7185H50.4364L46.437 20.0831L50.4364 24.3974H47.6847L45.0525 21.5211L42.3216 24.3974H33.8486V15.7185ZM35.9739 19.1018V17.515H41.3439L43.687 20.0503L41.2401 22.5994H35.9739V20.8687H40.6689V19.1018H35.9739ZM12.7355 15.7185H15.9267L19.5541 23.925V15.7185H23.0499L25.8517 21.6025L28.4338 15.7185H31.9122V24.4025H29.7957L29.7784 17.5978L26.6927 24.4025H24.7994L21.6964 17.5978V24.4025H17.3423L16.5168 22.4557H12.0571L11.2333 24.4008H8.90044L12.7355 15.7185ZM12.8186 20.6559L14.2879 17.1878L15.7555 20.6559H12.8186Z",
    fill: "#1F72CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "static/media/Amex.0fb28971b30e8fa4f8306cc023aee113.svg";
export { ForwardRef as ReactComponent };